document.addEventListener('DOMContentLoaded', function() {
  const expandableDescriptions = document.querySelectorAll('[data-expandable]');
  
  expandableDescriptions.forEach(function(container) {
    const btn = container.querySelector('.read-more-btn');
    
    if (btn) {
      btn.addEventListener('click', function() {
        const shortTexts = container.querySelectorAll('.description-short');
        const fullTexts = container.querySelectorAll('.description-full');
        const showMore = this.querySelector('.show-more');
        const showLess = this.querySelector('.show-less');
        
        const isExpanded = fullTexts[0].style.display !== 'none';
        
        if (!isExpanded) {
          shortTexts.forEach(text => text.style.display = 'none');
          fullTexts.forEach(text => text.style.display = 'inline');
          showMore.style.display = 'none';
          showLess.style.display = 'inline';
        } else {
          shortTexts.forEach(text => text.style.display = 'inline');
          fullTexts.forEach(text => text.style.display = 'none');
          showMore.style.display = 'inline';
          showLess.style.display = 'none';
        }
      });
    }
  });
});